import { ApplicationContextType } from "../../../interfaces/interfaces";
import { getFirstShareholdersGridInvalidRange } from "../../Underwriting/CompanyDetails/Shareholder/shareholderHelper";
import { findFirstDebtorScheduleGridError } from "../../Underwriting/Revenue Details/DebtorSchedule/debtorScheduleHelper";
import { findFirstDebtScheduleGridError } from "../../Underwriting/Revenue Details/DebtSchedule/debtScheduleHelper";

export const validateBusinessUpdateStep = (values, monthYear) => {
  const errors = {};
  const missingData = [];

  if (!values?.shareholderDetails) {
    errors["shareholderDetails"] = "Add your company’s shareholding details";
    missingData.push("Add your company’s shareholding details");
  } else {
    const shareholderGridError = getFirstShareholdersGridInvalidRange(
      values.shareholderDetails
    );
    if (shareholderGridError) {
      errors["shareholderDetails"] = "Add your company’s shareholding details";
      missingData.push("Add your company’s shareholding details");
    }
  }

  const invalidDebtRange = findFirstDebtScheduleGridError(
    values?.debtSchedule,
    false
  );
  console.log("invalidDebtRange", invalidDebtRange);
  if (invalidDebtRange) {
    errors["debtSchedule"] = "Details Missing";
    missingData.push("Details Missing");
  }

  const invalidDebtorRange = findFirstDebtorScheduleGridError(
    values?.debtorSchedule,
    ApplicationContextType.monthlyReport,
    false
  );
  if (invalidDebtorRange) {
    errors["debtorSchedule"] = "Details Missing";
    missingData.push("Details Missing");
  }

  if (values?.newProductLaunch) {
    const currentMontYearFields = values?.newProductLaunch[monthYear];
    if (currentMontYearFields && currentMontYearFields?.isValid == "yes") {
      if (!currentMontYearFields?.products) {
        missingData.push("Add newly launched products");
      }
    }
  }

  if (values?.newMarketplace) {
    const currentMontYearFields = values?.newMarketplace[monthYear];
    if (currentMontYearFields && currentMontYearFields?.isValid == "yes") {
      if (!currentMontYearFields?.marketplaces) {
        missingData.push("Add newly launched marketplaces");
      }
    }
  }

  if (values?.unsoldInventory) {
    const currentMontYearFields = values?.unsoldInventory[monthYear];
    if (!currentMontYearFields?.value) {
      missingData.push("Add unsold inventory");
    }
  }

  return {
    errors,
    allErrors: {
      missingData: missingData,
    },
  };
};
